import { observer } from 'mobx-react-lite'
import { ReactNode, useEffect, useState } from 'react'
import GoogleLogin, { GoogleLogout } from 'react-google-login'
import { Link, useHistory } from 'react-router-dom'
import logo from '../eye-mask.svg'
import { GOOGLE_CLIENT_ID } from '../models/constants'
import { ProgStatus } from '../models/utilTypes'
import LogInStore from '../stores/LogInStore'
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";
import { StyledHeader } from '../components/StyledHeader'

//const loginStore = new LogInStore()
const LogInComp = () => {


    const [loginStore] = useState(new LogInStore())
    const [loginState, setLoginState] = useState<ProgStatus>('INIT')
    let history = useHistory()

    useEffect(() => {

        if (loginStore.logInProgress == 'SUCCESS')
            history.replace('/stapp/home')


    })

    function login() {
        setLoginState('SUCCESS')
    }

    function checkDisabled(): boolean {

        if (loginStore.userName == '' || loginStore.password == '')
            return true
        else return false

    }

    function getStatus(): ReactNode {


        switch (loginStore.logInProgress) {

            case 'LOADING': return <progress className="pure-material-progress-circular" />
                break;

            default: return 'Log In'

        }
    }

    const responseGoogle = (response: any) => {
        console.log(response);
        loginStore.handleGoogleAuthresponse(response)
    }

    const responseFailGoogle = (response: any) => {
        console.log(response);
    }

    return (
        <motion.div className='absolute flex-column main-cont ' style={{ width: '100%', height: '100%' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div style={{ position: 'absolute', top: 20, left: 20 }} >
                <StyledHeader heading='Sign In' />
            </div>
            <div className='container center-align card' style={{ padding: 28 }} >
                <img src={logo} alt="" style={{ width: '200px', height: '100px' }} />
                <div style={{ height: 10 }} ></div>
                <div className='flex-column'>
                    <label htmlFor="">Username</label>
                    <input className='input-field' type="text" name="" id="" maxLength={10}
                        onChange={(event) => {
                            loginStore.setUserName(event.target.value)
                        }} />
                    <label htmlFor="">Password</label>
                    <input className='input-field' type="password" name="" id="" maxLength={20}
                        onChange={(event) => {
                            loginStore.setPassword(event.target.value)
                        }} />
                </div>
                <button className='button-5 button-fixed'
                    onClick={() => loginStore.logInUser()}
                    disabled={checkDisabled()}
                    style={{ width: 216, marginTop: 20 }}
                >{getStatus()}</button>
                <h3>Or</h3>
                <div >
                    <GoogleLogin
                        clientId={GOOGLE_CLIENT_ID}
                        buttonText="Login with Google"
                        onSuccess={responseGoogle}
                        onFailure={responseFailGoogle}
                    />
                </div>
            </div>
            <div className='flex-column center-align' style={{ position: 'absolute', bottom: 10 }} >
                <h4>Don't have an account yet?</h4>
                <Link to='/stapp/register' >
                    <p style={{ color: 'purple', fontWeight: 700 }} >Sign Up</p>
                </Link>
            </div>
        </motion.div>
    )
}

export const LogIn = observer(LogInComp)